<h2 class="my-1">Delivery Estimates</h2>
<p class="my-4">
  If you select an address from the search field when adding a delivery,
  HireLogic will lookup Google Maps to get the distance and duration to that
  location. HireLogic will use the properties below to determine a price
  estiamte for each vehicle type (small, medium, large). The distance or
  duration is multiplied by the factor for each vehicle type, and then rounded
  as per the settings below.
</p>
<form
  [formGroup]="form"
  (ngSubmit)="onSubmit(model)"
  class="flex flex-col justify-start items-stretch"
>
  <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
  <button
    type="submit"
    mat-flat-button
    color="primary"
    class="self-center"
    [disabled]="!form.valid"
  >
    Save
  </button>
</form>
